(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cart"]) return;
  try {
    
  var products = [
    { title: 'Classic Birthday Sponge Cake - 7" Round', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 9" Round', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 10" Round', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 11"x7"', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 10" Square', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 12" Round', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 12" Square', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 14" Square', days: 1 },
    { title: 'Classic Birthday Sponge Cake - 16" Square', days: 1 },
    { title: 'Classic Birthday Sponge Cake - Slab (16"x24")', days: 1 },
    { title: 'Black Forest Cake - 7" Round', days: 1 },
    { title: 'Black Forest Cake - 9" Round', days: 1 },
    { title: 'Black Forest Cake - 10" Round', days: 1 },
    { title: 'Black Forest Cake - 10" Square', days: 1 },
    { title: 'Black Forest Cake - 12" Round', days: 1 },
    { title: 'Black Forest Cake - 12" Square', days: 1 },
    { title: 'Black Forest Cake - 14" Square', days: 1 },
    { title: 'Italian Torte - 7" Round', days: 1 },
    { title: 'Italian Torte - 9" Round', days: 1 },
    { title: 'Italian Torte - 10" Round', days: 1 },
    { title: 'Italian Torte - 12" Round', days: 1 },
    { title: 'Italian Torte - 10" Square', days: 1 },
    { title: 'Italian Torte - 12" Square', days: 1 },
    { title: 'Italian Torte - 14" Square', days: 1 },
    { title: 'Cannoli Tower', days: 2 },
    { title: 'Profiterole Tower - 25 Profiteroles', days: 2 },
    { title: 'Profiterole Tower - 40 Profiteroles', days: 2 },
    { title: 'Profiterole Tower - 60 Profiteroles', days: 2 },
    { title: 'Profiterole Tower - 80 Profiteroles', days: 2 },
    { title: 'White Chocolate & Caramel Cake - 7" Round', days: 1 },
    { title: 'White Chocolate & Caramel Cake - 9" Round', days: 3 },
    { title: 'White Chocolate & Caramel Cake - 10" Round', days: 3 },
    { title: 'White Chocolate & Caramel Cake - 12" Square', days: 3 },
    { title: 'White Chocolate & Caramel Cake - 14" Square', days: 3 },
    { title: 'White Chocolate & Strawberry Cake - 7" Round', days: 1 },
    { title: 'White Chocolate & Strawberry Cake - 9" Round', days: 3 },
    { title: 'White Chocolate & Strawberry Cake - 10" Round', days: 3 },
    { title: 'White Chocolate & Strawberry Cake - 12" Square', days: 3 },
    { title: 'White Chocolate & Strawberry Cake - 14" Square', days: 3 },
    { title: 'Vanilla & Chocolate Cake - 7" Round', days: 1 },
    { title: 'Vanilla & Chocolate Cake - 9" Round', days: 3 },
    { title: 'Vanilla & Chocolate Cake - 10" Round', days: 3 },
    { title: 'Vanilla & Chocolate Cake - 12" Square', days: 3 },
    { title: 'Vanilla & Chocolate Cake - 14" Square', days: 3 },
    { title: 'Deluxe Christmas Cake', days: 1 },
    { title: 'Milkshake Deluxe Cake - 7" Round', days: 1 },
    { title: 'Milkshake Deluxe Cake - 9" Round', days: 3 },
    { title: 'Milkshake Deluxe Cake - 10" Round', days: 3 },
    { title: 'Milkshake Deluxe Cake - 12" Round', days: 3 },
    { title: 'Milkshake Deluxe Cake - 14" Square', days: 3 },
    { title: 'Cookies & Cream Deluxe - 7" Round', days: 1 },
    { title: 'Cookies & Cream Deluxe - 9" Round', days: 3 },
    { title: 'Cookies & Cream Deluxe - 10" Round', days: 3 },
    { title: 'Cookies & Cream Deluxe - 12" Round', days: 3 },
    { title: 'Cookies & Cream Deluxe - 14" Square', days: 3 },
    { title: 'Carrot Cake Deluxe - 7" Round', days: 1 },
    { title: 'Carrot Cake Deluxe - 9" Round', days: 3 },
    { title: 'Carrot Cake Deluxe - 10" Round', days: 3 },
    { title: 'Carrot Cake Deluxe - 12" Round', days: 3 },
    { title: 'Carrot Cake Deluxe - 14" Square', days: 3 },
    { title: 'Caramel Deluxe Cake - 7" Round', days: 1 },
    { title: 'Caramel Deluxe Cake - 9" Round', days: 3 },
    { title: 'Caramel Deluxe Cake - 10" Round', days: 3 },
    { title: 'Caramel Deluxe Cake - 12" Round', days: 3 },
    { title: 'Caramel Deluxe Cake - 14" Square', days: 3 },
    { title: 'Citrus Lemon Deluxe Cake - 7" Round', days: 1 },
    { title: 'Citrus Lemon Deluxe Cake - 9" Round', days: 3 },
    { title: 'Citrus Lemon Deluxe Cake - 10" Round', days: 3 },
    { title: 'Citrus Lemon Deluxe Cake - 12" Round', days: 3 },
    { title: 'Citrus Lemon Deluxe Cake - 14" Square', days: 3 },
    { title: 'Biscoff Deluxe - 7" Round', days: 1 },
    { title: 'Biscoff Deluxe - 9" Round', days: 3 },
    { title: 'Biscoff Deluxe - 10" Round', days: 3 },
    { title: 'Biscoff Deluxe - 12" Round', days: 3 },
    { title: 'Biscoff Deluxe - 14" Square', days: 3 },
    { title: 'Rocky Road Deluxe Cake - 7" Round', days: 1 },
    { title: 'Rocky Road Deluxe Cake - 9" Round', days: 3 },
    { title: 'Rocky Road Deluxe Cake - 10" Round', days: 3 },
    { title: 'Rocky Road Deluxe Cake - 12" Round', days: 3 },
    { title: 'Rocky Road Deluxe Cake - 14" Square', days: 3 },
    { title: 'Red Velvet Deluxe Cake - 7" Round', days: 1 },
    { title: 'Red Velvet Deluxe Cake - 9" Round', days: 3 },
    { title: 'Red Velvet Deluxe Cake - 10" Round', days: 3 },
    { title: 'Red Velvet Deluxe Cake - 12" Round', days: 3 },
    { title: 'Red Velvet Deluxe Cake - 14" Square', days: 3 },
    { title: 'Chocolate MudCake - 7" Round', days: 1 },
    { title: 'Chocolate MudCake - 9" Round', days: 1 },
    { title: 'Chocolate MudCake - 10" Round', days: 3 },
    { title: 'Chocolate MudCake - 12" Round', days: 3 },
    { title: 'Chocolate MudCake - 10" Square', days: 3 },
    { title: 'Chocolate MudCake - 12" Square', days: 3 },
    { title: 'Chocolate MudCake - 14" Square', days: 3 },
    { title: 'Chocolate MudCake - 16" Square', days: 3 },
    { title: 'Chocolate MudCake - 11"x7"', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 7" Round', days: 1 },
    { title: 'Gluten Free Chocolate MudCake - 9" Round', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 10" Round', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 12" Round', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 10" Square', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 12" Square', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 14" Square', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 16" Square', days: 3 },
    { title: 'Gluten Free Chocolate MudCake - 11"x7"', days: 3 },
    { title: '7" Nutella Bomb', days: 1 },
    { title: 'Classic Birthday Butter Cake - 7" Round', days: 3 },
    { title: 'Classic Birthday Butter Cake - 9" Round', days: 3 },
    { title: 'Classic Birthday Butter Cake - 10" Round', days: 3 },
    { title: 'Classic Birthday Butter Cake - 12" Round', days: 3 },
    { title: 'Classic Birthday Butter Cake - 10" Square', days: 3 },
    { title: 'Classic Birthday Butter Cake - 12" Square', days: 3 },
    { title: 'Classic Birthday Butter Cake - 14" Square', days: 3 },
    { title: 'Classic Birthday Butter Cake - 16" Square', days: 3 },
    { title: 'Classic Birthday Butter Cake - 11"x7"', days: 3 },
    { title: 'Pavlova - 7"', days: 1 },
    { title: 'Pavlova - 9"', days: 1 },
    { title: 'Baked Cheese Cake - 7" Round', days: 1 },
    { title: 'Baked Cheese Cake - 9" Round', days: 1 },
    { title: 'Cold Cheesecakes - 7" Round', days: 1 },
    { title: 'Cold Cheesecakes - 9" Round', days: 1 },
    { title: 'Almond Tart - 9"', days: 3 },
    { title: 'Fruit Flan Tart - 9"', days: 3 },
    { title: 'Key Lime Tart - 7"', days: 3 },
    { title: 'Key Lime Tart - 9"', days: 3 },
    { title: 'Lemon Meringue - 7"', days: 3 },
    { title: 'Lemon Meringue - 9"', days: 3 },
    { title: 'Pavlova - 9"', days: 3 },
    { title: 'Salted Caramel Tart - 9"', days: 3 },
    { title: 'Diplomat Pudding - 7"', days: 2 },
    { title: 'Diplomat Pudding - 9"', days: 2 },
  ];

  var mothersDayProducts = ["Mother's Day Vintage Heart Cake", "Mother's Day Cupcake Box", "Mother's Day Hamper"];

  var datepickerDays = 0;
  var extraCalendarDays = 0;
  var specialityCakesProducts = [];
  var christmasProducts = [];
  var easternProducts = [];
  var valentinesDayProducts = [];
  var fondantFinishProducts = [];
  var fathersDayProducts = [];
  var glutenFreeCupcakesProducts = [];
  var isSpecialityCake = false;
  var hasChristmasProducts = false;
  var hasMothersDayProducts = false;
  var hasFathersDayProducts = false;
  var hasValentinesDayProducts = false;
  var hasEasternProducts = false;
  var hasFondantFinishProducts = false;
  var hasGlutenFreeCupcakes = false;
  var cartTotal = 0;
  var isLetterOrNumberCake = false;
  var hasPaidCustomizations = false;
  var isMoreThan3DaysProduct = false;
  var is3dCarProduct = false;
  var dateRange = [];
  var availableOnDates = [];
  var isFilledHotCrossBuns = false;
  var isCatering = false;
  var hasMerchandise = false;
  var merchandiseProducts = [];
  var noMerchandiseProduct = false;
  var checkedProducts = 0;
  var allNoDatepicker = typeof window.cartConfig !== 'undefined' && window.cartConfig.allNoDatepicker ? true : false;
  var noDatepickerItemsCount = 0;
  var regularProductsCount = 0;

  $.getJSON('/collections/christmas/products.json?limit=250', function (response) {
    response.products.forEach(function (product) {
      christmasProducts.push(product.title);
    });
  });

  $.getJSON('/collections/valentines-day/products.json?limit=250', function (response) {
    response.products.forEach(function (product) {
      valentinesDayProducts.push(product.title);
    });
  });

  $.getJSON('/collections/easter-2024/products.json?limit=250', function (response) {
    response.products.forEach(function (product) {
      easternProducts.push(product.title);
    });
  });

  $.getJSON('/collections/fondant-finish/products.json?limit=250', function (response) {
    response.products.forEach(function (product) {
      fondantFinishProducts.push(product.title);
    });
  });

  $.getJSON('/collections/only-fathers-day/products.json?limit=250', function (response) {
    response.products.forEach(function (product) {
      fathersDayProducts.push(product.title);
    });
  });

  $.getJSON('/collections/gluten-free-cupcakes/products.json?limit=250', function (response) {
    response.products.forEach(function (product) {
      glutenFreeCupcakesProducts.push(product.title);
    });
  });

  for (var i = 1; i < 3; i++) {
    $.getJSON('/collections/speciality-cakes/products.json?limit=250&page=' + i, function (response) {
      response.products.forEach(function (product) {
        specialityCakesProducts.push(product.title);
      });
    });
  }

  var detectSpecialityCakesProducts = setInterval(function () {
    if (specialityCakesProducts.length > 250) {
      $.getJSON('/cart.js', function (cart) {
        if (cart.item_count > 0) {
          $('#choose-delivery-date').show();

          cartTotal = cart.total_price / 100;

          // Hides the Delivery Date button if the user empties the cart
          var mutationTarget = $('.empty-page-content')[0];
          var mutationObs = new MutationObserver(function () {
            $('#choose-delivery-date').hide();
          });

          mutationObs.observe(mutationTarget, { attributes: true });

          var extrasTotal = 0;
          var sweetCatering = [];
          var savouryCatering = [];
          var cannoli = [];
          var muffins = [];
          var funKidsCupcakes = [];

          cart.items.forEach(function (element) {
            var itemIsNoDatepicker = false;

            $.getJSON(window.Shopify.routes.root + 'products/' + element.handle + '.js', function (response) {
              if (response.tags) {
                var foundNoDatepicker = response.tags.some(function (tag) {
                  return (tag || '').toLowerCase().trim() === 'no-datepicker';
                });
                if (foundNoDatepicker) {
                  itemIsNoDatepicker = true;
                }
              }

              if (!itemIsNoDatepicker) {
                response.tags.forEach(function (tag) {
                  if (tag.includes('Days')) {
                    var days = parseInt(tag.replace(/\D/g, ''));
                    if (days > datepickerDays) {
                      datepickerDays = days;
                    }
                  }
                  if (tag.includes('available_from') && dateRange.length < 2) {
                    dateRange.push(tag.split(':')[1]);
                  }
                  if (tag.includes('available_to') && dateRange.length < 2) {
                    dateRange.push(tag.split(':')[1]);
                  }
                  if (tag.includes('available_on') && dateRange.length < 2) {
                    var availableOnTag = tag.split(':')[1];
                    availableOnTag = availableOnTag.split('-');

                    availableOnTag.forEach(function (date) {
                      var currentDate = date.replace('/', '-');
                      var currentYear = new Date().getFullYear();
                      availableOnDates.push(currentDate + '-' + currentYear);
                    });
                  }
                });
              }
            });

            $.ajax({
              type: 'GET',
              url: 'https://custom.fizdigital.online/getProductPoles.php?product_id=' + element.product_id,
              dataType: 'JSON',
              async: false,
              success: function (response) {
                var polesTagsLower = '';
                if (response && response.product && response.product.tags) {
                  polesTagsLower = Array.isArray(response.product.tags)
                    ? response.product.tags.join(',').toLowerCase()
                    : String(response.product.tags).toLowerCase();
                }

                if (polesTagsLower.includes('no-datepicker')) {
                  itemIsNoDatepicker = true;
                }

                if (
                  response.product.tags.includes('+4') ||
                  response.product.tags.includes('+5') ||
                  response.product.tags.includes('+6')
                ) {
                  if (!itemIsNoDatepicker) {
                    isMoreThan3DaysProduct = true;
                  }
                }
                if (response.product.tags.includes('merchandise')) {
                  hasMerchandise = true;
                  merchandiseProducts.push(element.variant_id);
                  checkedProducts += element.quantity;
                } else {
                  noMerchandiseProduct = true;
                  checkedProducts += element.quantity;
                }

                if (itemIsNoDatepicker) {
                  noDatepickerItemsCount += element.quantity;
                } else if (!response.product.tags.includes('merchandise')) {
                  regularProductsCount += element.quantity;
                }
              },
            });

            if (checkedProducts == cart.item_count) {
              if (noDatepickerItemsCount === cart.item_count) {
                allNoDatepicker = true;
              } else if (regularProductsCount > 0) {
                allNoDatepicker = false;
              }
            }

            if (hasMerchandise && noMerchandiseProduct && checkedProducts == cart.item_count) {
              document.getElementById('modalOverlay').style.display = 'flex';

              $('#closeModal').click(function () {
                const ajaxPromises = merchandiseProducts.map(function (merchandiseProduct) {
                  const queryData = {
                    id: merchandiseProduct,
                    quantity: 0,
                  };

                  return $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: queryData,
                    dataType: 'json',
                  });
                });

                Promise.all(ajaxPromises)
                  .then(function () {
                    document.getElementById('modalOverlay').style.display = 'none';
                    window.location.reload();
                  })
                  .catch(function (error) {
                    console.error('One or more AJAX requests failed:', error);
                  });
              });
            }

            if (hasMerchandise || allNoDatepicker) {
              $('.btn-step-1').text('Continue to checkout');
            }

            if (element.product_title == '3D Car Cake') {
              is3dCarProduct = true;
            }

            if (element.product_title == 'Filled Hot Cross Buns (4Pack)') {
              isFilledHotCrossBuns = true;
            }

            if (element.product_title == 'Sweet Catering' || element.product_title == 'Savoury Catering') {
              isCatering = true;
            }

            if (glutenFreeCupcakesProducts.includes(element.product_title)) {
              hasGlutenFreeCupcakes = true;
              extraCalendarDays = 2;
            }

            if (mothersDayProducts.includes(element.product_title)) {
              // hasMothersDayProducts = true
            }

            if (fathersDayProducts.includes(element.product_title)) {
              hasFathersDayProducts = true;
            }

            if (specialityCakesProducts.includes(element.product_title) && !element.product_title.includes('Smash')) {
              isSpecialityCake = true;
            }

            if (christmasProducts.includes(element.product_title)) {
              hasChristmasProducts = true;
              extraCalendarDays = 2;
            }

            if (easternProducts.includes(element.product_title)) {
              hasEasternProducts = true;
            }

            if (valentinesDayProducts.includes(element.product_title)) {
              hasValentinesDayProducts = true;
            }

            if (fondantFinishProducts.includes(element.product_title)) {
              hasFondantFinishProducts = true;
            }

            if (element.product_title == 'Sweet Catering' || element.product_title == 'Savoury Catering') {
              extraCalendarDays = 4;
            }

            if (element.product_title == 'Letter or Number Cake') {
              isLetterOrNumberCake = true;
            }

            var productKey = element.key;
            var productExtra = 0;
            var productQuantity = element.quantity;

            // Check if the product has extras and if so save the value of
            // each extra into the productExtra variable
            if (element.properties) {
              var properties = Object.keys(element.properties);

              properties.forEach((key, index) => {
                var elem = element.properties[key];

                if (elem.slice(elem.length - 1) == ']') {
                  var addonPrice = elem.substring(elem.indexOf('$') + 1, elem.lastIndexOf(']'));

                  productExtra += parseFloat(addonPrice);
                }
              });
            }

            // Get the product table row
            var tableRow = $('tbody').find(`[data-cart-item-key='${productKey}']`);

            // Get element that contains "Price" column
            var currentProductPrice = $($(tableRow[0].children[1])[0]).find('[data-cart-item-regular-price]')[0]
              .innerText;
            currentProductPrice = parseFloat(currentProductPrice.substring(1));

            // Set new value for "Price" column
            var productNewPrice = currentProductPrice + productExtra;
            productNewPrice = productNewPrice.toFixed(2);
            $($(tableRow[0].children[1])[0]).find('[data-cart-item-regular-price]')[0].innerText =
              '$' + productNewPrice;

            // Set new value for "Total" column
            var productNewTotal = productNewPrice * productQuantity;
            productNewTotal = productNewTotal.toFixed(2);
            $($(tableRow[0].children[3])[0]).find('[data-cart-item-regular-price]')[0].innerText =
              '$' + productNewTotal;

            console.log(element.properties);

            if (element.properties && element.properties['_customization_total'] > 0) {
              hasPaidCustomizations = true;
            }

            if (element.properties && element.properties['Would you like to add a Cake Topper']) {
              var cake_topper = element.properties['Would you like to add a Cake Topper']
                .replace(/ /g, '')
                .substring(0, 3);

              if (cake_topper == 'Yes') {
                extraCalendarDays = 4;
              }
            }

            if (element.properties && element.properties['WOULD YOU LIKE A HB CHOCOLATE SIGN OR A CAKE TOPPER?']) {
              var cake_topper = element.properties['WOULD YOU LIKE A HB CHOCOLATE SIGN OR A CAKE TOPPER?']
                .replace(/ /g, '')
                .substring(0, 11);

              if (cake_topper == 'CakeTopper') {
                extraCalendarDays = 4;
              }
            }

            if (element.properties && element.properties['WOULD YOU LIKE TO ADD TEXT ON TOP OR A CAKE TOPPER?']) {
              var cake_topper = element.properties['WOULD YOU LIKE TO ADD TEXT ON TOP OR A CAKE TOPPER?']
                .replace(/ /g, '')
                .substring(0, 11);

              if (cake_topper == 'CakeTopper') {
                extraCalendarDays = 4;
              }
            }

            if (element.properties && element.properties['WOULD YOU LIKE A CAKE TOPPER?']) {
              var cake_topper = element.properties['WOULD YOU LIKE A CAKE TOPPER?'].replace(/ /g, '').substring(0, 10);

              if (cake_topper == 'YesPlease') {
                extraCalendarDays = 4;
              }
            }

            if (element.variant_title && element.variant_title == 'Vanilla Gluten Free') {
              extraCalendarDays = 2;
            }

            if (
              element.variant_title &&
              element.variant_title.includes('Gluten Free') &&
              element.variant_title != 'Vanilla Gluten Free'
            ) {
              extraCalendarDays = 3;
            }

            if (element.properties && element.properties['Please select your buttercake flavour']) {
              var flavour = element.properties['Please select your buttercake flavour'];

              if (flavour.includes('GF')) {
                extraCalendarDays = 3;
              }
            }

            if (element.properties && element.properties['Please select your buttercake flavour - top tier']) {
              var flavour = element.properties['Please select your buttercake flavour - top tier'];

              if (flavour.includes('GF')) {
                extraCalendarDays = 7;
              }
            }

            if (element.properties && element.properties['Please select your buttercake flavour - bottom tier']) {
              var flavour = element.properties['Please select your buttercake flavour - bottom tier'];

              if (flavour.includes('GF')) {
                extraCalendarDays = 7;
              }
            }

            if (element.properties && element.properties['Please select your buttercake flavour - middle tier']) {
              var flavour = element.properties['Please select your buttercake flavour - middle tier'];

              if (flavour.includes('GF')) {
                extraCalendarDays = 7;
              }
            }

            if (element.properties && element.properties['FLAVOUR']) {
              var flavour = element.properties['FLAVOUR'];

              if (flavour.includes('GF')) {
                extraCalendarDays = 7;
              }
            }

            if (!itemIsNoDatepicker) {
              parsedProductTitle = element.title.replace(/&amp;/g, '&');
              parsedProductTitle = parsedProductTitle.replace(/&quot;/g, '"');

              var product = products.filter((product) => product.title === parsedProductTitle);

              if (product.length > 0) {
                if (product[0].days > extraCalendarDays) {
                  extraCalendarDays = product[0].days;
                }
              }
            }

            var minDay = new Date().getDay() + extraCalendarDays;

            /*if (minDay == 6) {
            extraCalendarDays += 2
          }
    
    	  if (minDay == 7) { 
            extraCalendarDays += 1
          }*/

            if (!$.isEmptyObject(element.properties) && element.properties.hasOwnProperty('_preparation_days')) {
              var preparation_days = JSON.parse(element.properties._preparation_days);

              if (element.variant_title && element.variant_title.includes('"')) {
                var variant_size = element.variant_title.split('"')[0];

                preparation_days.forEach(function (days, index) {
                  if (days.includes(variant_size + '-')) {
                    extraCalendarDays = parseInt(days.split('-')[1]);
                  }
                });
              } else {
                extraCalendarDays = parseInt(preparation_days[0]);
              }
            }

            extrasTotal += productExtra * productQuantity;

            if (element.handle == 'sweet-catering') {
              var sweetCateringRow = $('tbody').find(`[data-cart-item-key='${element.key}']`);
              $(sweetCateringRow).css('display', 'none');
              sweetCatering.push(element);
            }

            if (element.handle == 'savoury-catering') {
              var savouryCateringRow = $('tbody').find(`[data-cart-item-key='${element.key}']`);
              $(savouryCateringRow).css('display', 'none');
              savouryCatering.push(element);
            }

            if (element.handle == 'cannoli') {
              var cannoliRow = $('tbody').find(`[data-cart-item-key='${element.key}']`);
              $(cannoliRow).css('display', 'none');
              cannoli.push(element);
            }

            if (element.handle == 'muffins') {
              var muffinsRow = $('tbody').find(`[data-cart-item-key='${element.key}']`);
              $(muffinsRow).css('display', 'none');
              muffins.push(element);
            }

            if (element.handle == 'fun-kids-cupcakes') {
              var funKidsCupcakesRow = $('tbody').find(`[data-cart-item-key='${element.key}']`);
              $(funKidsCupcakesRow).css('display', 'none');
              funKidsCupcakes.push(element);
            }

            var handles = [
              'complex-finish-fondant-cupcake',
              'mini-figurine-cupcake',
              'one-colour-swirl-cupcake',
              'simple-finish-fondant-cupcakes',
              'fun-kids-cupcakes',
              'chocolate-elegant-cupcake-gf-option',
              '2-colours-swirl-cupcake',
            ];

            if (handles.includes(element.handle)) {
              var tableElement = $('tbody').find(`[data-cart-item-key='${element.key}']`)[0];
              var tableElementQtyInput = $(tableElement).find('.cart__qty-input')[1];
              $(tableElementQtyInput).prop('readonly', true);
            }
          });

          if (sweetCatering.length > 0) {
            var sweetCateringTotal = 0;
            var sweetCateringVariantsToUpdate = {};

            $($('table').find('[data-cart-line-items]')).append(`
              <tr class="cart__row">
                  <td class="cart__meta small--text-left" data-cart-table-cell="">
                      <div class="cart__product-information">
                        <div class="cart__image-wrapper">
                          <img class="cart__image" src="//cdn.shopify.com/s/files/1/0574/6694/5711/products/Catering-Mini-Pastries-Pastry-Lemon-Meringue-Fruit-Flan-Neenish-Tarts-Curd-Caramel-Chocolate-Danish-Custard-French-Rockcake-Baked-Goods_x190.jpg?v=1622647228" alt="" data-cart-item-image="" style="cursor: pointer;">
                        </div>
                        <div>
                          <div class="list-view-item__title">
                            <a href="/products/sweet-catering" class="cart__product-title" data-cart-item-title="" data-role="product-title">
                              Sweet Catering
                            </a>
                          </div>
                          <ul class="product-details sweet-catering-options">
                          </ul>
                          <p class="cart__remove">
                            <a href="#" class="remove-sweet-catering">Remove</a>
                          </p>
                        </div>
                      </div>  
                  </td>
    
                  <td class="cart__price text-right">
                    <div data-cart-item-price="">
                        <dl data-cart-item-price-list="">
                            <div data-cart-item-regular-price-group="">
                                <dt>
                                    <span class="visually-hidden">Regular price</span>
                                </dt>
                                <dd data-cart-item-regular-price="" class="sweet-catering-price"></dd>
                            </div>
                        </dl>
                    </div> 
                  </td>
    
                  <td class="cart__quantity-td text-right small--hide"> 
                    <div class="cart__qty">
                      <label for="" class="cart__qty-label" data-quantity-label-desktop="">Quantity</label>
                      <input id="" class="cart__qty-input" type="number" name="updates[]" value="1" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="3" data-quantity-input-desktop="" data-role="product-quantity-desktop" readonly>
                    </div> 
                  </td>
    
                  <td class="cart__final-price text-right small--hide" data-cart-item-line-price="">
                    <div data-cart-item-regular-price-group="">
                      <span data-cart-item-regular-price="" class="sweet-catering-total-price"></span>  
                    </div>
                  </td>
              </tr>
          `);

            sweetCatering.forEach(function (cateringItem) {
              $('.sweet-catering-options').append(`
    			<li class="product-details__item product-details__item--variant-option"> 
                  ${cateringItem.quantity} x ${cateringItem.variant_title} 
               </li>`);

              sweetCateringTotal += cateringItem.final_line_price;
              sweetCateringVariantsToUpdate[cateringItem.variant_id] = 0;
            });

            sweetCateringTotal = (sweetCateringTotal / 100).toFixed(2);

            $('.sweet-catering-price').html('$' + sweetCateringTotal);
            $('.sweet-catering-total-price').html('$' + sweetCateringTotal);

            $('.remove-sweet-catering').click(function () {
              $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                  updates: sweetCateringVariantsToUpdate,
                },
                success: function (resultData) {
                  window.location.reload();
                },
              });
            });
          }

          if (savouryCatering.length > 0) {
            var savouryCateringTotal = 0;
            var savouryCateringVariantsToUpdate = {};

            $($('table').find('[data-cart-line-items]')).append(`
              <tr class="cart__row">
                  <td class="cart__meta small--text-left" data-cart-table-cell="">
                      <div class="cart__product-information">
                        <div class="cart__image-wrapper">
                          <img class="cart__image" src="//cdn.shopify.com/s/files/1/0574/6694/5711/products/Catering-Mini-Pastries-Pastry-Lemon-Meringue-Fruit-Flan-Neenish-Tarts-Curd-Caramel-Chocolate-Danish-Custard-French-Rockcake-Baked-Goods_x190.jpg?v=1622647228" alt="" data-cart-item-image="" style="cursor: pointer;">
                        </div>
                        <div>
                          <div class="list-view-item__title">
                            <a href="/products/savoury-catering" class="cart__product-title" data-cart-item-title="" data-role="product-title">
                              Savoury Catering
                            </a>
                          </div>
                          <ul class="product-details savoury-catering-options">
                          </ul>
                          <p class="cart__remove">
                            <a href="#" class="remove-savoury-catering">Remove</a>
                          </p>
                        </div>
                      </div>  
                  </td>
    
                  <td class="cart__price text-right">
                    <div data-cart-item-price="">
                        <dl data-cart-item-price-list="">
                            <div data-cart-item-regular-price-group="">
                                <dt>
                                    <span class="visually-hidden">Regular price</span>
                                </dt>
                                <dd data-cart-item-regular-price="" class="savoury-catering-price"></dd>
                            </div>
                        </dl>
                    </div> 
                  </td>
    
                  <td class="cart__quantity-td text-right small--hide"> 
                    <div class="cart__qty">
                      <label for="" class="cart__qty-label" data-quantity-label-desktop="">Quantity</label>
                      <input id="" class="cart__qty-input" type="number" name="updates[]" value="1" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="3" data-quantity-input-desktop="" data-role="product-quantity-desktop" readonly>
                    </div> 
                  </td>
    
                  <td class="cart__final-price text-right small--hide" data-cart-item-line-price="">
                    <div data-cart-item-regular-price-group="">
                      <span data-cart-item-regular-price="" class="savoury-catering-total-price"></span>  
                    </div>
                  </td>
              </tr>
          `);

            var cooked_or_frozen = '';

            savouryCatering.forEach(function (cateringItem) {
              $('.savoury-catering-options').append(`
    			<li class="product-details__item product-details__item--variant-option"> 
                  ${cateringItem.quantity} x ${cateringItem.variant_title} 
               </li>`);

              cooked_or_frozen = Object.values(cateringItem.properties)[0];

              savouryCateringTotal += cateringItem.final_line_price;
              savouryCateringVariantsToUpdate[cateringItem.variant_id] = 0;
            });

            $('.savoury-catering-options').append(`
            <li class="product-details__item product-details__item--variant-option"> 
              <strong>Cooked or frozen?:</strong> ${cooked_or_frozen} 
           </li>`);

            savouryCateringTotal = (savouryCateringTotal / 100).toFixed(2);

            $('.savoury-catering-price').html('$' + savouryCateringTotal);
            $('.savoury-catering-total-price').html('$' + savouryCateringTotal);

            $('.remove-savoury-catering').click(function () {
              $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                  updates: savouryCateringVariantsToUpdate,
                },
                success: function (resultData) {
                  window.location.reload();
                },
              });
            });
          }

          if (cannoli.length > 0) {
            var cannoliTotal = 0;
            var cannoliVariantsToUpdate = {};

            $($('table').find('[data-cart-line-items]')).append(`
              <tr class="cart__row">
                  <td class="cart__meta small--text-left" data-cart-table-cell="">
                      <div class="cart__product-information">
                        <div class="cart__image-wrapper">
                          <img class="cart__image" src="//cdn.shopify.com/s/files/1/0574/6694/5711/products/Cannoli-Vanilla-Chocolate-Custard-Italian-Pastry-Icing-Sugar-Fried-Indulge-Treat2_x190.jpg?v=1622559845" alt="" data-cart-item-image="" style="cursor: pointer;">
                        </div> 
                        <div>
                          <div class="list-view-item__title">
                            <a href="/products/cannoli" class="cart__product-title" data-cart-item-title="" data-role="product-title">
                              Cannoli
                            </a> 
                          </div>
                          <ul class="product-details cannoli-options">
                          </ul>
                          <p class="cart__remove">
                            <a href="#" class="remove-cannoli">Remove</a>
                          </p>
                        </div>
                      </div>  
                  </td>
    
                  <td class="cart__price text-right">
                    <div data-cart-item-price="">
                        <dl data-cart-item-price-list="">
                            <div data-cart-item-regular-price-group="">
                                <dt>
                                    <span class="visually-hidden">Regular price</span>
                                </dt>
                                <dd data-cart-item-regular-price="" class="cannoli-price"></dd>
                            </div>
                        </dl>
                    </div> 
                  </td>
    
                  <td class="cart__quantity-td text-right small--hide"> 
                    <div class="cart__qty">
                      <label for="" class="cart__qty-label" data-quantity-label-desktop="">Quantity</label>
                      <input id="" class="cart__qty-input" type="number" name="updates[]" value="1" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="3" data-quantity-input-desktop="" data-role="product-quantity-desktop" readonly>
                    </div> 
                  </td>
    
                  <td class="cart__final-price text-right small--hide" data-cart-item-line-price="">
                    <div data-cart-item-regular-price-group="">
                      <span data-cart-item-regular-price="" class="cannoli-total-price"></span>  
                    </div>
                  </td>
              </tr>
          `);

            cannoli.forEach(function (cannoliItem) {
              $('.cannoli-options').append(`
    			<li class="product-details__item product-details__item--variant-option"> 
                  ${cannoliItem.quantity} x ${cannoliItem.variant_title} 
               </li>`);

              cannoliTotal += cannoliItem.final_line_price;
              cannoliVariantsToUpdate[cannoliItem.variant_id] = 0;
            });

            cannoliTotal = (cannoliTotal / 100).toFixed(2);

            $('.cannoli-price').html('$' + cannoliTotal);
            $('.cannoli-total-price').html('$' + cannoliTotal);

            $('.remove-cannoli').click(function () {
              $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                  updates: cannoliVariantsToUpdate,
                },
                success: function (resultData) {
                  window.location.reload();
                },
              });
            });
          }

          if (muffins.length > 0) {
            var muffinsTotal = 0;
            var muffinsVariantsToUpdate = {};

            $($('table').find('[data-cart-line-items]')).append(`
              <tr class="cart__row">
                  <td class="cart__meta small--text-left" data-cart-table-cell="">
                      <div class="cart__product-information">
                        <div class="cart__image-wrapper">
                          <img class="cart__image" src="//cdn.shopify.com/s/files/1/0574/6694/5711/products/Muffin-Muffins-Baking-Bake-Topping-Fillings-Fruity-Fruits-Chocolate-White-Dark-Sweets-Raspberry-Filled-Jam_x190.jpg?v=1622574011" alt="" data-cart-item-image="" style="cursor: pointer;">
                        </div>
                        <div>
                          <div class="list-view-item__title">
                            <a href="/products/muffins" class="cart__product-title" data-cart-item-title="" data-role="product-title">
                              Muffins
                            </a>
                          </div>
                          <ul class="product-details muffins-options">
                          </ul>
                          <p class="cart__remove">
                            <a href="#" class="remove-muffins">Remove</a>
                          </p>
                        </div>
                      </div>  
                  </td>
    
                  <td class="cart__price text-right">
                    <div data-cart-item-price="">
                        <dl data-cart-item-price-list="">
                            <div data-cart-item-regular-price-group="">
                                <dt>
                                    <span class="visually-hidden">Regular price</span>
                                </dt>
                                <dd data-cart-item-regular-price="" class="muffins-price"></dd>
                            </div>
                        </dl>
                    </div> 
                  </td>
    
                  <td class="cart__quantity-td text-right small--hide"> 
                    <div class="cart__qty">
                      <label for="" class="cart__qty-label" data-quantity-label-desktop="">Quantity</label>
                      <input id="" class="cart__qty-input" type="number" name="updates[]" value="1" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="3" data-quantity-input-desktop="" data-role="product-quantity-desktop" readonly>
                    </div> 
                  </td>
    
                  <td class="cart__final-price text-right small--hide" data-cart-item-line-price="">
                    <div data-cart-item-regular-price-group="">
                      <span data-cart-item-regular-price="" class="muffins-total-price"></span>  
                    </div>
                  </td>
              </tr>
          `);

            muffins.forEach(function (muffinsItem) {
              $('.muffins-options').append(`
    			<li class="product-details__item product-details__item--variant-option"> 
                  ${muffinsItem.quantity} x ${muffinsItem.variant_title} 
               </li>`);

              muffinsTotal += muffinsItem.final_line_price;
              muffinsVariantsToUpdate[muffinsItem.variant_id] = 0;
            });

            muffinsTotal = (muffinsTotal / 100).toFixed(2);

            $('.muffins-price').html('$' + muffinsTotal);
            $('.muffins-total-price').html('$' + muffinsTotal);

            $('.remove-muffins').click(function () {
              $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                  updates: muffinsVariantsToUpdate,
                },
                success: function (resultData) {
                  window.location.reload();
                },
              });
            });
          }

          if (funKidsCupcakes.length > 0) {
            var funKidsCupcakesTotal = 0;
            var funKidsCupcakesVariantsToUpdate = {};

            $($('table').find('[data-cart-line-items]')).append(`
              <tr class="cart__row">
                  <td class="cart__meta small--text-left" data-cart-table-cell="">
                      <div class="cart__product-information">
                        <div class="cart__image-wrapper">
                          <img class="cart__image" src="//cdn.shopify.com/s/files/1/0574/6694/5711/products/Studio-Session-162-scaled_x190.jpg?v=1622665023" alt="" data-cart-item-image="" style="cursor: pointer;">
                        </div>
                        <div>
                          <div class="list-view-item__title">
                            <a href="/products/fun-kids-cupcakes" class="cart__product-title" data-cart-item-title="" data-role="product-title">
                              Fun Kids Cupcakes
                            </a>
                          </div>
                          <ul class="product-details fun-kids-cupcakes-options">
                          </ul>
                          <p class="cart__remove">
                            <a href="#" class="remove-fun-kids-cupcakes">Remove</a>
                          </p>
                        </div>
                      </div>  
                  </td>
    
                  <td class="cart__price text-right">
                    <div data-cart-item-price="">
                        <dl data-cart-item-price-list="">
                            <div data-cart-item-regular-price-group="">
                                <dt>
                                    <span class="visually-hidden">Regular price</span>
                                </dt>
                                <dd data-cart-item-regular-price="" class="fun-kids-cupcakes-price"></dd>
                            </div>
                        </dl>
                    </div> 
                  </td>
    
                  <td class="cart__quantity-td text-right small--hide"> 
                    <div class="cart__qty">
                      <label for="" class="cart__qty-label" data-quantity-label-desktop="">Quantity</label>
                      <input id="" class="cart__qty-input" type="number" name="updates[]" value="1" min="0" pattern="[0-9]*" data-quantity-input="" data-quantity-item="3" data-quantity-input-desktop="" data-role="product-quantity-desktop" readonly>
                    </div> 
                  </td>
    
                  <td class="cart__final-price text-right small--hide" data-cart-item-line-price="">
                    <div data-cart-item-regular-price-group="">
                      <span data-cart-item-regular-price="" class="fun-kids-cupcakes-total-price"></span>  
                    </div>
                  </td>
              </tr>
          `);

            funKidsCupcakes.forEach(function (funKidsCupcakesItem) {
              $('.fun-kids-cupcakes-options').append(`
    			<li class="product-details__item product-details__item--variant-option"> 
                  ${funKidsCupcakesItem.quantity} x ${funKidsCupcakesItem.variant_title} 
               </li>`);

              funKidsCupcakesTotal += funKidsCupcakesItem.final_line_price;
              funKidsCupcakesVariantsToUpdate[funKidsCupcakesItem.variant_id] = 0;
            });

            funKidsCupcakesTotal = (funKidsCupcakesTotal / 100).toFixed(2);

            $('.fun-kids-cupcakes-price').html('$' + funKidsCupcakesTotal);
            $('.fun-kids-cupcakes-total-price').html('$' + funKidsCupcakesTotal);

            $('.remove-fun-kids-cupcakes').click(function () {
              $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/update.js',
                data: {
                  updates: funKidsCupcakesVariantsToUpdate,
                },
                success: function (resultData) {
                  window.location.reload();
                },
              });
            });
          }

          var carSubTotal = cart.items_subtotal_price / 100;

          var newCarSubTotal = carSubTotal + extrasTotal;
          newCarSubTotal = newCarSubTotal.toFixed(2);

          $('.cart-subtotal__price')[0].innerText = '$' + newCarSubTotal + ' AUD';
        }
      });

      clearInterval(detectSpecialityCakesProducts);
    }
  });

  var detectOldDatepicker = setInterval(function () {
    if ($('.ot-delivery-date').length > 0) {
      $('.ot-delivery-date').remove();
      clearInterval(detectOldDatepicker);
    }
  }, 100);

  if (allNoDatepicker || hasMerchandise) {
    $('#choose-delivery-date')
      .html(`Continue to checkout <i class='fas fa-chevron-right'></i>`)
      .removeAttr('disabled');
  } else {
    $('#choose-delivery-date')
      .html(`Choose a Delivery / Pick Up Date <i class='fas fa-chevron-right'></i>`)
      .removeAttr('disabled');
  }

  var detectDatepicker = setInterval(function () {
    if ($('#custom-shipping-date').length > 0) {
      cartDatepicker = $('#custom-shipping-date');

      if (allNoDatepicker || hasMerchandise) {
        $('#choose-delivery-date')
          .html(`Continue to checkout <i class='fas fa-chevron-right'></i>`)
          .removeAttr('disabled');
      } else {
        $('#choose-delivery-date')
          .html(`Choose a Delivery / Pick Up Date <i class='fas fa-chevron-right'></i>`)
          .removeAttr('disabled');
      }

      $('.delivery-date-error').hide();
      $('.delivery-time-error').hide();

      $('#custom-shipping-method').change(function () {
        var selected = $(this).val();

        $('#custom-shipping-date').val('');
        $('#custom-shipping-time').val('');

        var dateRangeFromTo = [];
        var availableOnDatesArr = [];

        if (dateRange.length > 0) {
          var dateFromParts = dateRange[0].split('-');

          var startDate = new Date(+dateFromParts[2], dateFromParts[1] - 1, +dateFromParts[0]);

          var dateToParts = dateRange[1].split('-');

          var endDate = new Date(+dateToParts[2], dateToParts[1] - 1, +dateToParts[0]);

          function getDates(startDate, endDate) {
            const dates = [];
            let currentDate = startDate;
            const addDays = function (days) {
              const date = new Date(this.valueOf());
              date.setDate(date.getDate() + days);
              return date;
            };
            while (currentDate <= endDate) {
              dates.push(currentDate);
              currentDate = addDays.call(currentDate, 1);
            }
            return dates;
          }

          var dates = getDates(startDate, endDate);

          dates.forEach(function (date) {
            var rangeDate = date.toLocaleString('en-GB').split(',')[0];

            var rangeDateParts = rangeDate.split('/');

            if (rangeDateParts[0].startsWith('0')) {
              rangeDateParts[0] = rangeDateParts[0].substring(1);
            }

            if (rangeDateParts[1].startsWith('0')) {
              rangeDateParts[1] = rangeDateParts[1].substring(1);
            }

            var rangeDateFormatted = rangeDateParts[0] + '-' + rangeDateParts[1] + '-' + rangeDateParts[2];

            dateRangeFromTo.push(rangeDateFormatted);
          });
        }

        if (availableOnDates.length > 0) {
          availableOnDates.forEach(function (date) {
            var availableOnDateParts = date.split('-');

            if (availableOnDateParts[0].startsWith('0')) {
              availableOnDateParts[0] = availableOnDateParts[0].substring(1);
            }

            if (availableOnDateParts[1].startsWith('0')) {
              availableOnDateParts[1] = availableOnDateParts[1].substring(1);
            }

            var avilableOnDateFormatted =
              availableOnDateParts[0] + '-' + availableOnDateParts[1] + '-' + availableOnDateParts[2];

            availableOnDatesArr.push(avilableOnDateFormatted);
          });
        }

        if (selected == 'Delivery') {
          $('#custom-shipping-date').attr('placeholder', 'Delivery date');
        } else if (selected == 'Pick Up') {
          $('#custom-shipping-date').attr('placeholder', 'Pick Up date');
          $('select option:contains("Shipping time")').text('Pick Up time');
        } else {
          $('#custom-shipping-date').attr('placeholder', 'Delivery / Pick Up date');
          $('select option:contains("Pick Up time")').text('Shipping time');
        }

        $('.custom-pick-up-text').hide();
        $('.custom-delivery-notes').hide();
        $('.custom-pickup-notes').hide();
        $('.custom-terms').hide();
        $('#continue-to-checkout').hide();
        datepickerId = Object.getOwnPropertyNames(cartDatepicker[0])[1];

        if (selected != '') {
          if (selected == 'Delivery') {
            cartDatepicker[0][datepickerId].datepicker.settings.beforeShowDay = function (date) {
              var day = date.getDay();
              var dateDay = date.getDate();
              var month = date.getMonth() + 1;
              var year = date.getFullYear();
              var fullDate = dateDay + '-' + month + '-' + year;

              var blockedDates = [
                '23-12-2022',
                '24-12-2022',
                '25-12-2022',
                '26-12-2022',
                '27-12-2022',
                '1-1-2023',
                '23-1-2023',
                '24-1-2023',
                '25-1-2023',
                '26-1-2023',
                '27-1-2023',
                '28-1-2023',
                '29-1-2023',
                '30-1-2023',
                '31-1-2023',
                '1-2-2023',
                '2-2-2023',
                '3-2-2023',
                '4-2-2023',
                '5-2-2023',
                '6-2-2023',
                '7-2-2023',
                '8-2-2023',
                '9-2-2023',
                '10-2-2023',
                '11-2-2023',
                '12-2-2023',
                '13-2-2023',
                '14-2-2023',
                '15-2-2023',
                '7-4-2023',
                '9-4-2023',
                '14-5-2023',
                '29-5-2023',
                '30-5-2023',
                '31-5-2023',
                '1-6-2023',
                '2-6-2023',
                '3-6-2023',
                '4-6-2023',
                '5-6-2023',
                '6-6-2023',
                '7-6-2023',
                '25-12-2023',
                '26-12-2023',
                '29-3-2024', // Disable 29th March 2024
                '31-3-2024', // Disable 31st March 2024
              ];

              var allBlocked = [
                '3-6-2023',
                '22-12-2023',
                '23-12-2023',
                '24-12-2023',
                '25-12-2023',
                '26-12-2023',
                '29-3-2024', // Disable 29th March 2024
                '31-3-2024', // Disable 31st March 2024
                '25-12-2024',
                '26-12-2024',
                '1-1-2025',
                '18-4-2025',
                '19-4-2025',
                '20-4-2025',
                '25-4-2025',
                '5-7-2025',
                '26-7-2025',
                '27-7-2025',
                '7-9-2025',
                '21-12-2025',
                '22-12-2025',
                '23-12-2025',
                '24-12-2025',
                '25-12-2025',
                '26-12-2025',
                '27-12-2025',
                '28-12-2025',
                '29-12-2025',
                '1-1-2026',
                '1-4-2026',
                '2-4-2026',
                '3-4-2026',
                '4-4-2026',
                '5-4-2026',
                '6-4-2026',
                '25-4-2026',
                '9-5-2026',
                '10-5-2026',
                '20-8-2026',
                '21-8-2026',
                '22-8-2026',
                '23-8-2026',
                '4-9-2026',
                '5-9-2026',
                '6-9-2026',
                '7-9-2026',
              ];

              var specialityCakesDates = [
                '31-7-2023',
                '1-8-2023',
                '2-8-2023',
                '3-8-2023',
                '4-8-2023',
                '5-8-2023',
                '6-8-2023',
                '7-8-2023',
                '8-8-2023',
                '9-8-2023',
                '10-8-2023',
                '11-8-2023',
                '12-8-2023',
                '13-8-2023',
                '14-8-2023',
                '15-8-2023',
                '16-8-2023',
                '17-8-2023',
                '18-8-2023',
                '19-8-2023',
                '20-8-2023',
                '21-8-2023',
                '22-8-2023',
                '23-8-2023',
                '24-8-2023',
                '25-8-2023',
                '26-8-2023',
                '27-8-2023',
                '28-8-2023',
                '29-8-2023',
                '25-9-2023',
                '26-9-2023',
                '27-9-2023',
                '28-9-2023',
                '29-9-2023',
                '30-9-2023',
                '1-10-2023',
                '2-10-2023',
                '3-10-2023',
                '4-10-2023',
                '5-10-2023',
                '6-10-2023',
                '7-10-2023',
                '8-10-2023',
                '9-10-2023',
                '10-10-2023',
                '11-10-2023',
                '12-10-2023',
                '13-10-2023',
                '14-10-2023',
                '15-10-2023',
                '16-10-2023',
                '17-10-2023',
                '18-10-2023',
                '19-10-2023',
                '20-10-2023',
                '21-10-2023',
                '22-10-2023',
                '23-10-2023',
                '24-10-2023',
                '25-10-2023',
                '30-10-2023',
                '31-10-2023',
                '1-11-2023',
                '2-11-2023',
                '3-11-2023',
                '4-11-2023',
                '5-11-2023',
                '6-11-2023',
                '7-11-2023',
                '8-11-2023',
                '1-12-2023',
                '2-12-2023',
                '3-12-2023',
                '4-12-2023',
                '5-12-2023',
                '6-12-2023',
                '7-12-2023',
                '8-12-2023',
                '9-12-2023',
                '10-12-2023',
                '11-12-2023',
                '12-12-2023',
                '13-12-2023',
                '14-12-2023',
                '15-12-2023',
                '16-12-2023',
                '17-12-2023',
                '18-12-2023',
                '19-12-2023',
                '20-12-2023',
                '21-12-2023',
                '22-12-2023',
                '23-12-2023',
                '24-12-2023',
                '25-12-2023',
                '26-12-2023',
                '27-12-2023',
                '28-12-2023',
                '1-1-2024',
                '2-1-2024',
                '3-1-2024',
                '4-1-2024',
                '5-1-2024',
                '6-1-2024',
                '7-1-2024',
                '8-1-2024',
                '9-1-2024',
                '10-1-2024',
                '11-1-2024',
                '12-1-2024',
                '13-1-2024',
                '14-1-2024',
                '15-1-2024',
                '16-1-2024',
                '17-1-2024',
                '24-2-2024',
                '25-2-2024',
                '26-2-2024',
                '27-2-2024',
                '28-2-2024',
                '29-2-2024',
                '1-3-2024',
                '2-3-2024',
                '3-3-2024',
                '4-3-2024',
                '5-3-2024',
                '6-3-2024',
                '7-3-2024',
                '8-3-2024',
                '9-3-2024',
                '10-3-2024',
                '11-3-2024',
                '12-3-2024',
                '13-3-2024',
                '3-4-2024',
                '4-4-2024',
                '5-4-2024',
                '6-4-2024',
                '7-4-2024',
                '8-4-2024',
                '9-4-2024',
                '22-4-2024',
                '23-4-2024',
                '24-4-2024',
                '25-4-2024',
                '26-4-2024',
                '27-4-2024',
                '28-4-2024',
                '29-4-2024',
                '30-4-2024',
                '1-5-2024',
                '2-5-2024',
                '3-5-2024',
                '4-5-2024',
                '5-5-2024',
                '6-5-2024',
                '7-5-2024',
                '8-5-2024',
                '9-5-2024',
                '10-5-2024',
                '11-5-2024',
                '12-5-2024',
                '13-5-2024',
                '14-5-2024',
                '15-5-2024',
                '16-5-2024',
                '17-5-2024',
                '18-5-2024',
                '19-5-2024',
                '20-5-2024',
                '21-5-2024',
                '22-5-2024',
                '23-5-2024',
                '24-5-2024',
                '25-5-2024',
                '26-5-2024',
                '27-5-2024',
                '28-5-2024',
                '1-6-2024',
                '2-6-2024',
                '3-6-2024',
                '4-6-2024',
                '5-6-2024',
                '6-6-2024',
                '7-6-2024',
                '8-6-2024',
                '9-6-2024',
                '10-6-2024',
                '11-6-2024',
                '1-7-2024',
                '2-7-2024',
                '3-7-2024',
                '4-7-2024',
                '5-7-2024',
                '6-7-2024',
                '7-7-2024',
                '8-7-2024',
                '9-7-2024',
                '10-7-2024',
                '11-7-2024',
                '12-7-2024',
                '13-7-2024',
                '14-7-2024',
                '15-7-2024',
                '16-7-2024',
                '17-7-2024',
                '12-8-2024',
                '13-8-2024',
                '14-8-2024',
                '15-8-2024',
                '16-8-2024',
                '17-8-2024',
                '18-8-2024',
                '19-8-2024',
                '20-8-2024',
                '21-8-2024',
                '17-9-2024',
                '18-9-2024',
                '19-9-2024',
                '20-9-2024',
                '21-9-2024',
                '22-9-2024',
                '23-9-2024',
                '24-9-2024',
                '25-9-2024',
                '11-11-2024',
                '12-11-2024',
                '13-11-2024',
                '14-11-2024',
                '15-11-2024',
                '16-11-2024',
                '17-11-2024',
                '12-11-2024',
                '13-11-2024',
                '14-11-2024',
                '15-11-2024',
                '16-11-2024',
                '17-11-2024',
                '18-11-2024',
                '19-11-2024',
                '22-11-2024',
                '23-11-2024',
                '24-11-2024',
                '25-11-2024',
                '26-11-2024',
                '27-11-2024',
                '28-11-2024',
                '29-11-2024',
                '30-11-2024',
                '1-12-2024',
                '2-12-2024',
                '3-12-2024',
                '6-12-2024',
                '7-12-2024',
                '8-12-2024',
                '9-12-2024',
                '10-12-2024',
                '11-12-2024',
                '12-12-2024',
                '13-12-2024',
                '14-12-2024',
                '21-12-2024',
                '22-12-2024',
                '23-12-2024',
                '24-12-2024',
                '25-12-2024',
                '26-12-2024',
                '27-12-2024',
                '28-12-2024',
                '29-12-2024',
                '30-12-2024',
                '31-12-2024',
                '1-1-2025',
                '2-1-2025',
                '3-1-2025',
                '7-1-2025',
                '8-1-2025',
                '9-1-2025',
                '10-1-2025',
                '11-1-2025',
                '12-1-2025',
                '13-1-2025',
                '14-1-2025',
                '29-1-2025',
                '30-1-2025',
                '31-1-2025',
                '1-2-2025',
                '2-2-2025',
                '3-2-2025',
                '4-2-2025',
                '17-2-2025',
                '18-2-2025',
                '19-2-2025',
                '20-2-2025',
                '21-2-2025',
                '22-2-2025',
                '23-2-2025',
                '24-2-2025',
                '25-2-2025',
                '26-2-2025',
                '27-2-2025',
                '28-2-2025',
                '1-3-2025',
                '2-3-2025',
                '3-3-2025',
                '4-3-2025',
                '17-3-2025',
                '18-3-2025',
                '19-3-2025',
                '20-3-2025',
                '21-3-2025',
                '22-3-2025',
                '23-3-2025',
                '24-3-2025',
                '25-3-2025',
                '1-4-2025',
                '2-4-2025',
                '3-4-2025',
                '4-4-2025',
                '5-4-2025',
                '6-4-2025',
                '7-4-2025',
                '8-4-2025',
                '9-4-2025',
                '10-4-2025',
                '11-4-2025',
                '12-4-2025',
                '13-4-2025',
                '14-4-2025',
                '15-4-2025',
                '16-4-2025',
                '17-4-2025',
                '18-4-2025',
                '19-4-2025',
                '20-4-2025',
                '21-4-2025',
                '22-4-2025',
                '30-4-2025',
                '1-5-2025',
                '2-5-2025',
                '3-5-2025',
                '4-5-2025',
                '5-5-2025',
                '6-5-2025',
                '8-6-2025',
                '9-6-2025',
                '10-6-2025',
                '11-6-2025',
                '12-6-2025',
                '13-6-2025',
                '14-6-2025',
                '15-6-2025',
                '16-6-2025',
                '17-6-2025',
                '24-6-2025',
                '25-6-2025',
                '26-6-2025',
                '27-6-2025',
                '28-6-2025',
                '29-6-2025',
                '30-6-2025',
                '1-7-2025',
                '2-7-2025',
                '3-7-2025',
                '4-7-2025',
                '5-7-2025',
                '6-7-2025',
                '7-7-2025',
                '8-7-2025',
                '9-9-2025',
                '10-9-2025',
                '11-9-2025',
                '12-9-2025',
                '13-9-2025',
                '14-9-2025',
                '15-9-2025',
                '16-9-2025',
                '17-9-2025',
                '18-9-2025',
                '19-9-2025',
                '20-9-2025',
                '21-9-2025',
                '22-9-2025',
                '23-9-2025',
                '1-10-2025',
                '2-10-2025',
                '3-10-2025',
                '4-10-2025',
                '5-10-2025',
                '6-10-2025',
                '7-10-2025',
                '9-10-2025',
                '10-10-2025',
                '11-10-2025',
                '12-10-2025',
                '13-10-2025',
                '14-10-2025',
                '27-10-2025',
                '28-10-2025',
                '29-10-2025',
                '30-10-2025',
                '31-10-2025',
                '1-11-2025',
                '2-11-2025',
                '3-11-2025',
                '4-11-2025',
                '5-11-2025',
                '6-11-2025',
                '7-11-2025',
                '8-11-2025',
                '9-11-2025',
                '10-11-2025',
                '11-11-2025',
                '12-11-2025',
                '13-11-2025',
                '14-11-2025',
                '15-11-2025',
                '16-11-2025',
                '17-11-2025',
                '18-11-2025',
                '19-11-2025',
                '20-11-2025',
                '21-11-2025',
                '22-11-2025',
                '23-11-2025',
                '24-11-2025',
                '25-11-2025',
                '26-11-2025',
                '27-11-2025',
                '28-11-2025',
                '29-11-2025',
                '30-11-2025',
                '1-12-2025',
                '2-12-2025',
                '15-12-2025',
                '16-12-2025',
                '17-12-2025',
                '18-12-2025',
                '19-12-2025',
                '20-12-2025',
                '21-12-2025',
                '22-12-2025',
                '23-12-2025',
                '24-12-2025',
                '25-12-2025',
                '26-12-2025',
                '27-12-2025',
                '28-12-2025',
                '29-3-2026',
                '30-3-2026',
                '31-3-2026',
                '1-4-2026',
                '2-4-2026',
                '3-4-2026',
                '4-4-2026',
                '5-4-2026',
                '6-4-2026',
                '7-4-2026',
                '14-12-2026',
                '15-12-2026',
                '16-12-2026',
                '17-12-2026',
                '18-12-2026',
                '19-12-2026',
                '20-12-2026',
                '21-12-2026',
                '22-12-2026',
                '23-12-2026',
                '24-12-2026',
                '25-12-2026',
                '26-12-2026',
                '27-12-2026',
                '28-12-2026', 
              ];

              var moreThan3DaysDates = [
                '10-9-2024',
                '11-9-2024',
                '12-9-2024',
                '13-9-2024',
                '14-9-2024',
                '15-9-2024',
                '16-9-2024',
                '17-9-2024',
                '18-9-2024',
                '7-4-2025',
                '8-4-2025',
                '9-4-2025',
                '10-4-2025',
                '11-4-2025',
                '12-4-2025',
                '13-4-2025',
                '14-4-2025',
                '17-6-2025',
                '18-6-2025',
                '19-6-2025',
                '20-6-2025',
                '21-6-2025',
                '22-6-2025',
                '23-6-2025',
                '24-6-2025',
                '19-8-2025',
                '20-8-2025',
                '21-8-2025',
                '22-8-2025',
                '23-8-2025',
                '24-8-2025',
                '25-8-2025',
                '26-8-2025',
              ];

              var cateringDates = [
                '18-12-2025',
                '19-12-2025',
                '20-12-2025',
                '21-12-2025',
                '22-12-2025',
                '23-12-2025',
                '24-12-2025',
                '25-12-2025',
                '26-12-2025',
                '27-12-2025',
                '28-12-2025',
                '29-12-2025',
                '30-12-2025',
                '31-12-2025',
                '1-1-2026',
                '2-1-2026',
              ];

              if (
                cartTotal > 0 ||
                (dateDay > 15 && dateDay < 25 && month == 12 && year == 2024 && hasChristmasProducts)
              ) {
                if (is3dCarProduct) {
                  return [false, ''];
                } else if (isCatering) {
                  if ((cateringDates.includes(fullDate) || allBlocked.includes(fullDate)) && !isLetterOrNumberCake) {
                    return [false, ''];
                  } else {
                    return [day != 0, ''];
                  }
                } else if (availableOnDates.length > 0 && availableOnDatesArr.length > 0) {
                  if (availableOnDatesArr.includes(fullDate)) {
                    return [true, ''];
                  } else {
                    return [false, ''];
                  }
                } else if (dateRange.length > 0 && dateRangeFromTo.length > 0) {
                  if (dateRangeFromTo.includes(fullDate) && !allBlocked.includes(fullDate)) {
                    return [true, ''];
                  } else {
                    return [false, ''];
                  }
                } else if (hasFondantFinishProducts) {
                  if (dateDay >= 7 && dateDay <= 31 && month == 10 && year == 2024) {
                    return [false, ''];
                  } else if (dateDay >= 1 && dateDay <= 11 && month == 11 && year == 2024) {
                    return [false, ''];
                  } else {
                    if (
                      (blockedDates.includes(fullDate) ||
                        allBlocked.includes(fullDate) ||
                        specialityCakesDates.includes(fullDate)) &&
                      !isLetterOrNumberCake
                    ) {
                      return [false, ''];
                    } else {
                      return [day != 0, ''];
                    }
                  }
                } else if ((isSpecialityCake || cartTotal >= 150) && !allBlocked.includes(fullDate)) {
                  if (
                    (blockedDates.includes(fullDate) ||
                      allBlocked.includes(fullDate) ||
                      specialityCakesDates.includes(fullDate)) &&
                    !isLetterOrNumberCake
                  ) {
                    return [false, ''];
                  } else {
                    if (cartTotal > 50 && cartTotal < 150) {
                      if (day == 0 || day == 1 || day == 2 || day == 3 || allBlocked.includes(fullDate)) {
                        return [false, ''];
                      } else {
                        if (isMoreThan3DaysProduct && moreThan3DaysDates.includes(fullDate)) {
                          return [false, ''];
                        } else {
                          return [true, ''];
                        }
                      }
                    } else {
                      if (isMoreThan3DaysProduct && moreThan3DaysDates.includes(fullDate)) {
                        return [false, ''];
                      } else {
                        return [day != 0, ''];
                      }
                    }
                  }
                } else if (isMoreThan3DaysProduct) {
                  if (
                    (moreThan3DaysDates.includes(fullDate) || allBlocked.includes(fullDate)) &&
                    !isLetterOrNumberCake
                  ) {
                    return [false, ''];
                  } else {
                    return [day != 0, ''];
                  }
                } else if (hasFathersDayProducts) {
                  if (dateDay > 25 && dateDay <= 31 && month == 08 && year == 2024) {
                    return [true, ''];
                  } else {
                    return [false, ''];
                  }
                } else if (hasEasternProducts) {
                  if (dateDay > 10 && dateDay <= 31 && month == 03 && year == 2024) {
                    if (dateDay == 29 || dateDay == 31) {
                      return [false, ''];
                    }
                    return [true, ''];
                  } else {
                    return [false, ''];
                  }
                } else if (hasChristmasProducts) {
                  if (dateDay > 0 && dateDay < 25 && month == 12 && year == 2024) {
                    if (dateDay == 14 || dateDay == 15 || dateDay == 24) {
                      return [false, ''];
                    }
                    return [true, ''];
                  } else {
                    return [false, ''];
                  }
                } else if (hasMothersDayProducts) {
                  if (dateDay > 11 && dateDay < 14 && month == 05 && year == 2023) {
                    return [true, ''];
                  } else {
                    return [false, ''];
                  }
                } else if (cartTotal > 50 && cartTotal < 150) {
                  if (day == 0 || allBlocked.includes(fullDate)) {
                    return [false, ''];
                  } else {
                    return [true, ''];
                  }
                } else {
                  if (day == 0 || allBlocked.includes(fullDate)) {
                    return [false, ''];
                  } else {
                    return [true, ''];
                  }
                }
              } else {
                return [false, ''];
              }
            };

            $('.custom-delivery-notes').fadeIn();
            $('.custom-terms').fadeIn();
            $('#continue-to-checkout').fadeIn();
          } else {
            cartDatepicker[0][datepickerId].datepicker.settings.beforeShowDay = function (date) {
              var day = date.getDay();
              var dateDay = date.getDate();
              var month = date.getMonth() + 1;
              var year = date.getFullYear();
              var fullDate = dateDay + '-' + month + '-' + year;

              var blockedDates = [
                '23-12-2022',
                '24-12-2022',
                '25-12-2022',
                '26-12-2022',
                '27-12-2022',
                '1-1-2023',
                '23-1-2023',
                '24-1-2023',
                '25-1-2023',
                '26-1-2023',
                '27-1-2023',
                '28-1-2023',
                '29-1-2023',
                '30-1-2023',
                '31-1-2023',
                '1-2-2023',
                '2-2-2023',
                '3-2-2023',
                '4-2-2023',
                '5-2-2023',
                '6-2-2023',
                '7-2-2023',
                '8-2-2023',
                '9-2-2023',
                '10-2-2023',
                '11-2-2023',
                '12-2-2023',
                '13-2-2023',
                '14-2-2023',
                '15-2-2023',
                '7-4-2023',
                '9-4-2023',
                '14-5-2023',
                '29-5-2023',
                '30-5-2023',
                '31-5-2023',
                '1-6-2023',
                '2-6-2023',
                '3-6-2023',
                '4-6-2023',
                '5-6-2023',
                '6-6-2023',
                '7-6-2023',
                '29-3-2024', // Disable 29th March 2024
                '31-3-2024', // Disable 31st March 2024
              ];

              var allBlocked = [
                '3-6-2023',
                '25-12-2023',
                '26-12-2023',
                '1-1-2024',
                '29-3-2024', // Disable 29th March 2024
                '31-3-2024', // Disable 31st March 2024
                '25-12-2024',
                '26-12-2024',
                '1-1-2025',
                '18-4-2025',
                '20-4-2025',
                '25-4-2025',
                '5-7-2025',
                '7-9-2025',
                '21-12-2025',
                '22-12-2025',
                '23-12-2025',
                '24-12-2025',
                '25-12-2025',
                '26-12-2025',
                '27-12-2025',
                '28-12-2025',
                '29-12-2025',
                '1-1-2026',
                '1-4-2026',
                '2-4-2026',
                '3-4-2026',
                '4-4-2026',
                '5-4-2026',
                '6-4-2026',
                '25-4-2026',
                '9-5-2026',
                '10-5-2026',
                '20-8-2026',
                '21-8-2026',
                '22-8-2026',
                '23-8-2026',
                '4-9-2026',
                '5-9-2026',
                '6-9-2026',
                '7-9-2026',
              ];

              var specialityCakesDates = [
                '31-7-2023',
                '1-8-2023',
                '2-8-2023',
                '3-8-2023',
                '4-8-2023',
                '5-8-2023',
                '6-8-2023',
                '7-8-2023',
                '8-8-2023',
                '9-8-2023',
                '10-8-2023',
                '11-8-2023',
                '12-8-2023',
                '13-8-2023',
                '14-8-2023',
                '15-8-2023',
                '16-8-2023',
                '17-8-2023',
                '18-8-2023',
                '19-8-2023',
                '20-8-2023',
                '21-8-2023',
                '22-8-2023',
                '23-8-2023',
                '24-8-2023',
                '25-8-2023',
                '26-8-2023',
                '27-8-2023',
                '28-8-2023',
                '29-8-2023',
                '25-9-2023',
                '26-9-2023',
                '27-9-2023',
                '28-9-2023',
                '29-9-2023',
                '30-9-2023',
                '1-10-2023',
                '2-10-2023',
                '3-10-2023',
                '4-10-2023',
                '5-10-2023',
                '6-10-2023',
                '7-10-2023',
                '8-10-2023',
                '9-10-2023',
                '10-10-2023',
                '11-10-2023',
                '12-10-2023',
                '13-10-2023',
                '14-10-2023',
                '15-10-2023',
                '16-10-2023',
                '17-10-2023',
                '18-10-2023',
                '19-10-2023',
                '20-10-2023',
                '21-10-2023',
                '22-10-2023',
                '23-10-2023',
                '24-10-2023',
                '25-10-2023',
                '30-10-2023',
                '31-10-2023',
                '1-11-2023',
                '2-11-2023',
                '3-11-2023',
                '4-11-2023',
                '5-11-2023',
                '6-11-2023',
                '7-11-2023',
                '8-11-2023',
                '1-12-2023',
                '2-12-2023',
                '3-12-2023',
                '4-12-2023',
                '5-12-2023',
                '6-12-2023',
                '7-12-2023',
                '8-12-2023',
                '9-12-2023',
                '10-12-2023',
                '11-12-2023',
                '12-12-2023',
                '13-12-2023',
                '14-12-2023',
                '15-12-2023',
                '16-12-2023',
                '17-12-2023',
                '18-12-2023',
                '19-12-2023',
                '20-12-2023',
                '21-12-2023',
                '22-12-2023',
                '23-12-2023',
                '24-12-2023',
                '25-12-2023',
                '26-12-2023',
                '27-12-2023',
                '28-12-2023',
                '1-1-2024',
                '2-1-2024',
                '3-1-2024',
                '4-1-2024',
                '5-1-2024',
                '6-1-2024',
                '7-1-2024',
                '8-1-2024',
                '9-1-2024',
                '10-1-2024',
                '11-1-2024',
                '12-1-2024',
                '13-1-2024',
                '14-1-2024',
                '15-1-2024',
                '16-1-2024',
                '17-1-2024',
                '24-2-2024',
                '25-2-2024',
                '26-2-2024',
                '27-2-2024',
                '28-2-2024',
                '29-2-2024',
                '1-3-2024',
                '2-3-2024',
                '3-3-2024',
                '4-3-2024',
                '5-3-2024',
                '6-3-2024',
                '7-3-2024',
                '8-3-2024',
                '9-3-2024',
                '10-3-2024',
                '11-3-2024',
                '12-3-2024',
                '13-3-2024',
                '3-4-2024',
                '4-4-2024',
                '5-4-2024',
                '6-4-2024',
                '7-4-2024',
                '8-4-2024',
                '9-4-2024',
                '22-4-2024',
                '23-4-2024',
                '24-4-2024',
                '25-4-2024',
                '26-4-2024',
                '27-4-2024',
                '28-4-2024',
                '29-4-2024',
                '30-4-2024',
                '1-5-2024',
                '2-5-2024',
                '3-5-2024',
                '4-5-2024',
                '5-5-2024',
                '6-5-2024',
                '7-5-2024',
                '8-5-2024',
                '9-5-2024',
                '10-5-2024',
                '11-5-2024',
                '12-5-2024',
                '13-5-2024',
                '14-5-2024',
                '15-5-2024',
                '16-5-2024',
                '17-5-2024',
                '18-5-2024',
                '19-5-2024',
                '20-5-2024',
                '21-5-2024',
                '22-5-2024',
                '23-5-2024',
                '24-5-2024',
                '25-5-2024',
                '26-5-2024',
                '27-5-2024',
                '28-5-2024',
                '1-6-2024',
                '2-6-2024',
                '3-6-2024',
                '4-6-2024',
                '5-6-2024',
                '6-6-2024',
                '7-6-2024',
                '8-6-2024',
                '9-6-2024',
                '10-6-2024',
                '11-6-2024',
                '1-7-2024',
                '2-7-2024',
                '3-7-2024',
                '4-7-2024',
                '5-7-2024',
                '6-7-2024',
                '7-7-2024',
                '8-7-2024',
                '9-7-2024',
                '10-7-2024',
                '11-7-2024',
                '12-7-2024',
                '13-7-2024',
                '14-7-2024',
                '15-7-2024',
                '16-7-2024',
                '17-7-2024',
                '12-8-2024',
                '13-8-2024',
                '14-8-2024',
                '15-8-2024',
                '16-8-2024',
                '17-8-2024',
                '18-8-2024',
                '19-8-2024',
                '20-8-2024',
                '21-8-2024',
                '17-9-2024',
                '18-9-2024',
                '19-9-2024',
                '20-9-2024',
                '21-9-2024',
                '22-9-2024',
                '23-9-2024',
                '24-9-2024',
                '25-9-2024',
                '1-10-2025',
                '2-10-2025',
                '3-10-2025',
                '4-10-2025',
                '5-10-2025',
                '6-10-2025',
                '7-10-2025',
                '11-11-2024',
                '12-11-2024',
                '13-11-2024',
                '14-11-2024',
                '15-11-2024',
                '16-11-2024',
                '17-11-2024',
                '12-11-2024',
                '13-11-2024',
                '14-11-2024',
                '15-11-2024',
                '16-11-2024',
                '17-11-2024',
                '18-11-2024',
                '19-11-2024',
                '22-11-2024',
                '23-11-2024',
                '24-11-2024',
                '25-11-2024',
                '26-11-2024',
                '27-11-2024',
                '28-11-2024',
                '29-11-2024',
                '30-11-2024',
                '1-12-2024',
                '2-12-2024',
                '3-12-2024',
                '6-12-2024',
                '7-12-2024',
                '8-12-2024',
                '9-12-2024',
                '10-12-2024',
                '11-12-2024',
                '12-12-2024',
                '13-12-2024',
                '14-12-2024',
                '21-12-2024',
                '22-12-2024',
                '23-12-2024',
                '24-12-2024',
                '25-12-2024',
                '26-12-2024',
                '27-12-2024',
                '28-12-2024',
                '29-12-2024',
                '30-12-2024',
                '31-12-2024',
                '1-1-2025',
                '2-1-2025',
                '3-1-2025',
                '7-1-2025',
                '8-1-2025',
                '9-1-2025',
                '10-1-2025',
                '11-1-2025',
                '12-1-2025',
                '13-1-2025',
                '14-1-2025',
                '29-1-2025',
                '30-1-2025',
                '31-1-2025',
                '1-2-2025',
                '2-2-2025',
                '3-2-2025',
                '4-2-2025',
                '17-2-2025',
                '18-2-2025',
                '19-2-2025',
                '20-2-2025',
                '21-2-2025',
                '22-2-2025',
                '23-2-2025',
                '24-2-2025',
                '25-2-2025',
                '26-2-2025',
                '27-2-2025',
                '28-2-2025',
                '1-3-2025',
                '2-3-2025',
                '3-3-2025',
                '4-3-2025',
                '17-3-2025',
                '18-3-2025',
                '19-3-2025',
                '20-3-2025',
                '21-3-2025',
                '22-3-2025',
                '23-3-2025',
                '24-3-2025',
                '25-3-2025',
                '1-4-2025',
                '2-4-2025',
                '3-4-2025',
                '4-4-2025',
                '5-4-2025',
                '6-4-2025',
                '7-4-2025',
                '8-4-2025',
                '9-4-2025',
                '10-4-2025',
                '11-4-2025',
                '12-4-2025',
                '13-4-2025',
                '14-4-2025',
                '15-4-2025',
                '16-4-2025',
                '17-4-2025',
                '18-4-2025',
                '19-4-2025',
                '20-4-2025',
                '21-4-2025',
                '22-4-2025',
                '30-4-2025',
                '1-5-2025',
                '2-5-2025',
                '3-5-2025',
                '4-5-2025',
                '5-5-2025',
                '6-5-2025',
                '8-6-2025',
                '9-6-2025',
                '10-6-2025',
                '11-6-2025',
                '12-6-2025',
                '13-6-2025',
                '14-6-2025',
                '15-6-2025',
                '16-6-2025',
                '17-6-2025',
                '24-6-2025',
                '25-6-2025',
                '26-6-2025',
                '27-6-2025',
                '28-6-2025',
                '29-6-2025',
                '30-6-2025',
                '1-7-2025',
                '2-7-2025',
                '3-7-2025',
                '4-7-2025',
                '5-7-2025',
                '6-7-2025',
                '7-7-2025',
                '8-7-2025',
                '8-6-2025',
                '9-9-2025',
                '10-9-2025',
                '11-9-2025',
                '12-9-2025',
                '13-9-2025',
                '14-9-2025',
                '15-9-2025',
                '16-9-2025',
                '17-9-2025',
                '18-9-2025',
                '19-9-2025',
                '20-9-2025',
                '21-9-2025',
                '22-9-2025',
                '23-9-2025',
                '1-10-2025',
                '2-10-2025',
                '3-10-2025',
                '4-10-2025',
                '5-10-2025',
                '6-10-2025',
                '9-10-2025',
                '10-10-2025',
                '11-10-2025',
                '12-10-2025',
                '13-10-2025',
                '14-10-2025',
                '27-10-2025',
                '28-10-2025',
                '29-10-2025',
                '30-10-2025',
                '31-10-2025',
                '1-11-2025',
                '2-11-2025',
                '3-11-2025',
                '4-11-2025',
                '5-11-2025',
                '6-11-2025',
                '7-11-2025',
                '8-11-2025',
                '9-11-2025',
                '10-11-2025',
                '11-11-2025',
                '12-11-2025',
                '13-11-2025',
                '14-11-2025',
                '15-11-2025',
                '16-11-2025',
                '17-11-2025',
                '18-11-2025',
                '19-11-2025',
                '20-11-2025',
                '21-11-2025',
                '22-11-2025',
                '23-11-2025',
                '24-11-2025',
                '25-11-2025',
                '26-11-2025',
                '27-11-2025',
                '28-11-2025',
                '29-11-2025',
                '30-11-2025',
                '1-12-2025',
                '2-12-2025',
                '15-12-2025',
                '16-12-2025',
                '17-12-2025',
                '18-12-2025',
                '19-12-2025',
                '20-12-2025',
                '21-12-2025',
                '22-12-2025',
                '23-12-2025',
                '24-12-2025',
                '25-12-2025',
                '26-12-2025',
                '27-12-2025',
                '28-12-2025',
                '29-3-2026',
                '30-3-2026',
                '31-3-2026',
                '1-4-2026',
                '2-4-2026',
                '3-4-2026',
                '4-4-2026',
                '5-4-2026',
                '6-4-2026',
                '7-4-2026',
                '14-12-2026',
                '15-12-2026',
                '16-12-2026',
                '17-12-2026',
                '18-12-2026',
                '19-12-2026',
                '20-12-2026',
                '21-12-2026',
                '22-12-2026',
                '23-12-2026',
                '24-12-2026',
                '25-12-2026',
                '26-12-2026',
                '27-12-2026',
                '28-12-2026',
              ];

              var moreThan3DaysDates = [
                '10-9-2024',
                '11-9-2024',
                '12-9-2024',
                '13-9-2024',
                '14-9-2024',
                '15-9-2024',
                '16-9-2024',
                '17-9-2024',
                '18-9-2024',
                '7-4-2025',
                '8-4-2025',
                '9-4-2025',
                '10-4-2025',
                '11-4-2025',
                '12-4-2025',
                '13-4-2025',
                '14-4-2025',
                '17-6-2025',
                '18-6-2025',
                '19-6-2025',
                '20-6-2025',
                '21-6-2025',
                '22-6-2025',
                '23-6-2025',
                '24-6-2025',
                '19-8-2025',
                '20-8-2025',
                '21-8-2025',
                '22-8-2025',
                '23-8-2025',
                '24-8-2025',
                '25-8-2025',
                '26-8-2025',
              ];

              var cateringDates = [
                '18-12-2025',
                '19-12-2025',
                '20-12-2025',
                '21-12-2025',
                '22-12-2025',
                '23-12-2025',
                '24-12-2025',
                '25-12-2025',
                '26-12-2025',
                '27-12-2025',
                '28-12-2025',
                '29-12-2025',
                '30-12-2025',
                '31-12-2025',
                '1-1-2026',
                '2-1-2026',
              ];

              if (is3dCarProduct) {
                return [false, ''];
              } else if (isCatering) {
                if ((cateringDates.includes(fullDate) || allBlocked.includes(fullDate)) && !isLetterOrNumberCake) {
                  return [false, ''];
                } else {
                  return [true, ''];
                }
              } else if (dateRange.length > 0 && dateRangeFromTo.length > 0) {
                if (dateRangeFromTo.includes(fullDate) && !allBlocked.includes(fullDate)) {
                  return [true, ''];
                } else {
                  return [false, ''];
                }
              } else if (hasFondantFinishProducts) {
                if (dateDay >= 7 && dateDay <= 31 && month == 10 && year == 2024) {
                  return [false, ''];
                } else if (dateDay >= 1 && dateDay <= 11 && month == 11 && year == 2024) {
                  return [false, ''];
                } else {
                  if (
                    (blockedDates.includes(fullDate) ||
                      allBlocked.includes(fullDate) ||
                      specialityCakesDates.includes(fullDate)) &&
                    !isLetterOrNumberCake
                  ) {
                    return [false, ''];
                  } else {
                    return [true, ''];
                  }
                }
              } else if (isSpecialityCake) {
                if (
                  (blockedDates.includes(fullDate) ||
                    allBlocked.includes(fullDate) ||
                    specialityCakesDates.includes(fullDate)) &&
                  !isLetterOrNumberCake
                ) {
                  return [false, ''];
                } else {
                  if (isMoreThan3DaysProduct && moreThan3DaysDates.includes(fullDate)) {
                    return [false, ''];
                  } else {
                    return [true, ''];
                  }
                }
              } else if (isMoreThan3DaysProduct) {
                if ((moreThan3DaysDates.includes(fullDate) || allBlocked.includes(fullDate)) && !isLetterOrNumberCake) {
                  return [false, ''];
                } else {
                  return [true, ''];
                }
              } else if (hasFathersDayProducts) {
                if (
                  (dateDay > 25 && dateDay <= 31 && month == 08 && year == 2024) ||
                  (dateDay == 1 && month == 09 && year == 2024)
                ) {
                  return [true, ''];
                } else {
                  return [false, ''];
                }
              } else if (hasEasternProducts) {
                if (dateDay > 10 && dateDay <= 31 && month == 03 && year == 2024) {
                  if (dateDay == 29 || dateDay == 31) {
                    return [false, ''];
                  }
                  return [true, ''];
                } else {
                  return [false, ''];
                }
              } else if (hasChristmasProducts) {
                if (dateDay > 0 && dateDay < 25 && month == 12 && year == 2024) {
                  return [true, ''];
                } else {
                  return [false, ''];
                }
              } else if (hasMothersDayProducts) {
                if (dateDay > 11 && dateDay <= 13 && month == 05 && year == 2023) {
                  return [true, ''];
                } else {
                  return [false, ''];
                }
              } else {
                if (allBlocked.includes(fullDate)) {
                  return [false, ''];
                } else {
                  return [true, ''];
                }
              }
            };

            $('.custom-pick-up-text').fadeIn();
            $('.custom-pickup-notes').fadeIn();
            $('.custom-terms').fadeIn();
            $('#continue-to-checkout').fadeIn();
          }
        } else {
          $('.custom-pick-up-text').hide();
          $('.custom-delivery-notes').hide();
          $('.custom-pickup-notes').hide();
          $('.custom-terms').hide();
          $('#continue-to-checkout').hide();
        }
      });

      clearInterval(detectDatepicker);
    }
  }, 100);

  $('#custom-shipping-date').datepicker({
    dateFormat: 'dd/mm/y',
    onSelect: function () {
      if ($('#custom-shipping-method').val() == 'Delivery') {
        $('#custom-shipping-time-range-pickup-mon-sat').hide();
        $('#custom-shipping-time-range-pickup-thursday').hide();
        $('#custom-shipping-time-range-pickup-sunday').hide();

        $('#custom-shipping-time-range-pickup-mon-sat').removeClass('active');
        $('#custom-shipping-time-range-pickup-thursday').removeClass('active');
        $('#custom-shipping-time-range-pickup-sunday').removeClass('active');

        $('#custom-shipping-time-range-delivery').addClass('active');
        $('#custom-shipping-time-range-delivery').show();
      } else {
        var cartDatepicker = $('#custom-shipping-date');
        datepickerId = Object.getOwnPropertyNames(cartDatepicker[0])[1];
        cartDatepicker = cartDatepicker[0][datepickerId].datepicker;

        var selectedDate =
          cartDatepicker.selectedMonth + 1 + '/' + cartDatepicker.selectedDay + '/' + cartDatepicker.selectedYear;
        var currentDate = new Date(selectedDate);

        var currentDay = currentDate.getDay();

        if (currentDay == 1 || currentDay == 2 || currentDay == 3 || currentDay == 5 || currentDay == 6) {
          $('#custom-shipping-time-range-delivery').hide();
          $('#custom-shipping-time-range-pickup-thursday').hide();
          $('#custom-shipping-time-range-pickup-sunday').hide();

          $('#custom-shipping-time-range-delivery').removeClass('active');
          $('#custom-shipping-time-range-pickup-thursday').removeClass('active');
          $('#custom-shipping-time-range-pickup-sunday').removeClass('active');

          $('#custom-shipping-time-range-pickup-mon-sat').addClass('active');
          $('#custom-shipping-time-range-pickup-mon-sat').show();
        } else if (currentDay == 4) {
          $('#custom-shipping-time-range-delivery').hide();
          $('#custom-shipping-time-range-pickup-mon-sat').hide();
          $('#custom-shipping-time-range-pickup-sunday').hide();

          $('#custom-shipping-time-range-delivery').removeClass('active');
          $('#custom-shipping-time-range-pickup-mon-sat').removeClass('active');
          $('#custom-shipping-time-range-pickup-sunday').removeClass('active');

          $('#custom-shipping-time-range-pickup-thursday').addClass('active');
          $('#custom-shipping-time-range-pickup-thursday').show();
        } else if (currentDay == 0) {
          $('#custom-shipping-time-range-delivery').hide();
          $('#custom-shipping-time-range-pickup-mon-sat').hide();
          $('#custom-shipping-time-range-pickup-thursday').hide();

          $('#custom-shipping-time-range-delivery').removeClass('active');
          $('#custom-shipping-time-range-pickup-mon-sat').removeClass('active');
          $('#custom-shipping-time-range-pickup-thursday').removeClass('active');

          $('#custom-shipping-time-range-pickup-sunday').addClass('active');
          $('#custom-shipping-time-range-pickup-sunday').show();
        }
      }
    },
  });

  $('.btn-step-1').click(function () {
    if (hasMerchandise || allNoDatepicker) {
      $('.cart__submit.btn--small-wide').trigger('click');
    } else {
      cartDatepicker = $('#custom-shipping-date');
      datepickerId = Object.getOwnPropertyNames(cartDatepicker[0])[1];
      var today = new Date();

      cartDatepicker[0][datepickerId].datepicker.settings.minDate = datepickerDays;

      if (extraCalendarDays > datepickerDays) {
        // Get available date
        var currentDate = new Date();
        var result = currentDate.setDate(currentDate.getDate() + extraCalendarDays);
        var availableDate = new Date(result);

        cartDatepicker[0][datepickerId].datepicker.settings.minDate = extraCalendarDays;
      } else if (datepickerDays <= 0) {
        cartDatepicker[0][datepickerId].datepicker.settings.minDate = 1;
      }

      // Hide the cart table and products
      $('#cart-table-container').hide();
      $('.btn-step-1').hide();
      $('.cart-header__title').text('Delivery or Pick Up?');
      $($('.cart-header__title')[0].nextElementSibling).hide();
      $('.ot-delivery-date-title').hide();
      $('.ot-delivery-date-note').hide();
      $('.custom-pick-up-text').hide();
      $('.custom-delivery-notes').hide();
      $('.custom-pickup-notes').hide();
      $('.custom-terms').hide();
      $('#continue-to-checkout').hide();

      // Display step 1 (delivery date) and scroll to top
      $('.cart-step-1').fadeIn();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    }
  });

  $('#continue-to-checkout').click(function () {
    var selectedDate = $('#custom-shipping-date').val();
    var selectedTime = $('.delivery-pickup-time.active').val();
    var deliveryMethod = $('#custom-shipping-method').val();
    var cartToday = new Date(Date.now()).toLocaleString('en-GB').split(',')[0];
    var cartAttributes = {};

    if (deliveryMethod == 'Delivery') {
      selectedTime = '12:00 PM-05:00 PM';

      cartAttributes['Delivery Date'] = selectedDate;
      cartAttributes['Shipping Time'] = selectedTime;
      // cartAttributes['Delivery or Pick Up Date'] = null
      // cartAttributes['Delivery or Pick Up Time'] = null
    } else {
      cartAttributes['Pick Up Date'] = selectedDate;
      cartAttributes['Pick Up Time'] = selectedTime;
      // cartAttributes['Delivery or Pick Up Date'] = null
      // cartAttributes['Delivery or Pick Up Time'] = null
    }

    $('.delivery-date-error').hide();
    $('.delivery-time-error').hide();

    if (!deliveryMethod.length) {
      $('.delivery-method-error').show();
    } else if (!selectedDate.length) {
      $('.delivery-date-error').show();
    } else if (!selectedTime) {
      $('.delivery-time-error').show();
    } else if (!$('#accept-terms').is(':checked')) {
      $('.label-terms').css('color', 'red');
    } else if (localStorage.getItem('cartDate') != cartToday) {
      window.location.href = '/cart';
    } else {
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          attributes: cartAttributes,
        },
        dataType: 'json',
        success: function () {
          if (hasPaidCustomizations) {
            var products = [];
            var customizationTotal = 0;

            $.getJSON('/cart.js', function (cart) {
              $.each(cart.items, function (index, item) {
                if (!$.isEmptyObject(item.properties) && item.properties.hasOwnProperty('_customization_total')) {
                  var customizationCost = parseFloat(item.properties._customization_total);

                  var customizationObject = {
                    price: customizationCost,
                    title: 'Customization Cost for ' + item.product_title,
                    quantity: 1,
                    shipping: false,
                  };

                  customizationTotal += customizationCost;
                }

                if (Object.keys(item.properties).length) {
                  var parsedProperties = [];

                  for (const [key, value] of Object.entries(item.properties)) {
                    parsedProperties.push({
                      name: key,
                      value: value,
                    });
                  }

                  item.properties = parsedProperties;
                } else {
                  delete item.properties;
                }

                products.push(item);
                products.push(customizationObject);
              });

              products = JSON.stringify(products);

              attributes = [];

              if (deliveryMethod == 'Delivery') {
                selectedTime = '12:00 PM-05:00 PM';

                attributes.push({
                  name: 'Delivery Date',
                  value: selectedDate,
                });

                attributes.push({
                  name: 'Shipping Time',
                  value: selectedTime,
                });

                // cartAttributes['Delivery Date'] = selectedDate
                // cartAttributes['Shipping Time'] = selectedTime
                // cartAttributes['Delivery or Pick Up Date'] = null
                // cartAttributes['Delivery or Pick Up Time'] = null
              } else {
                attributes.push({
                  name: 'Pick Up Date',
                  value: selectedDate,
                });

                attributes.push({
                  name: 'Pick Up Time',
                  value: selectedTime,
                });

                // cartAttributes['Pick Up Date'] = selectedDate
                // cartAttributes['Pick Up Time'] = selectedTime
                // cartAttributes['Delivery or Pick Up Date'] = null
                // cartAttributes['Delivery or Pick Up Time'] = null
              }

              attributes = JSON.stringify(attributes);

              if (localStorage.getItem('discount')) {
                var discountCode = JSON.parse(localStorage.getItem('discount'));
                var cartTotalWithCustomizations = 0;
                var discountTotal = 0;

                $.each(cart.items, function (index, item) {
                  cartTotalWithCustomizations += item.presentment_price;
                });

                cartTotalWithCustomizations += customizationTotal;

                if (discountCode.price_rule.target_type != 'shipping_line') {
                  if (discountCode.price_rule.value_type == 'percentage') {
                    var percentage = discountCode.price_rule.value;
                    percentage = percentage.replace('-', '');
                    percentage = percentage.split('.')[0];

                    discountTotal = (cartTotalWithCustomizations * percentage) / 100;
                  } else if (discountCode.price_rule.value_type == 'fixed_amount') {
                    var amount = discountCode.price_rule.value;
                    amount = amount.replace('-', '');
                    amount = amount.split('.')[0];

                    discountTotal = amount;
                  }

                  var discount = {
                    description: discountCode.price_rule.title,
                    value_type: 'fixed_amount',
                    value: discountTotal,
                    amount: discountTotal,
                    title: discountCode.price_rule.title,
                  };

                  discount = JSON.stringify(discount);

                  $.post(
                    'https://custom.fizdigital.online/draftOrderPolesOptions.php',
                    {
                      products: products,
                      attributes: attributes,
                      discount: discount,
                      password: 'Poles',
                    },
                    function (res) {
                      var result = JSON.parse(res);
                      window.location = result.draft_order.invoice_url;
                    }
                  );
                } else {
                  var shipping_discount = {
                    title: discountCode.price_rule.title,
                    custom: true,
                    handle: null,
                    price: 0,
                  };

                  shipping_discount = JSON.stringify(shipping_discount);

                  $.post(
                    'https://custom.fizdigital.online/draftOrderPolesOptions.php',
                    {
                      products: products,
                      attributes: attributes,
                      shipping_discount: shipping_discount,
                      password: 'Poles',
                    },
                    function (res) {
                      var result = JSON.parse(res);
                      window.location = result.draft_order.invoice_url;
                    }
                  );
                }
              } else {
                $.post(
                  'https://custom.fizdigital.online/draftOrderPolesOptions.php',
                  {
                    products: products,
                    attributes: attributes,
                    password: 'Poles',
                  },
                  function (res) {
                    var result = JSON.parse(res);
                    window.location = result.draft_order.invoice_url;
                  }
                );
              }
            });
          } else {
            $('.cart__submit.btn--small-wide').trigger('click');
          }
        },
      });
    }
  });

  if (localStorage.getItem('cartDate')) {
    localStorage.removeItem('cartDate');
  }

  if (localStorage.getItem('discount')) {
    localStorage.removeItem('discount');
  }

  localStorage.setItem('cartDate', new Date(Date.now()).toLocaleString('en-GB').split(',')[0]);

  $('#apply_discount').click(function () {
    $('#discount-msg').hide();
    $('#discount-error').hide();

    $.post(
      'https://fizdigital.online/api/discount-lookup',
      {
        discount: $('#discount_code_custom').val(),
        password: 'Poles',
      },
      function (res) {
        var result = JSON.parse(res);
        if (result.errors) {
          $('#discount-error').show();
        } else {
          console.log(result);
          $('#discount-msg').show();
          $('.discount-name').text($('#discount_code_custom').val());
          localStorage.setItem('discount', res);
        }
      }
    );
  });

  $('#remove-discount').click(function () {
    $('#discount-msg').hide();
    $('#discount_code_custom').val('');
    localStorage.removeItem('discount');
  });

  $('.cart__qty-input').on('input', function () {
    setTimeout(function () {
      location.reload();
    }, 800);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"]) return;
  try {
    
/* JavaScript for the testimonials slider */
$(document).ready(function(){
  $('.testimonials-slider').owlCarousel({
    items: 1, // Display one testimonial at a time
    loop: true,
    autoplay: true,
    autoplaySpeed: 3000, // Set the autoplay speed in milliseconds
    dots: true,
    nav: false
  });
});

  } catch(e) { console.error(e); }
})();
})();
